/** The columns of the funds grid a person can sort by; the server does the sorting. */
export const FUND_SORT_COLUMNS = [
    'name',
    'whoKnows',
    'tier',
    'stages',
    'investorType',
    'hqCountries',
    'regions',
    'recentInvestments',
    'lastContact',
    'coInvested',
    'notableInvestments',
    'sectors',
    'owners',
    'cheque',
    'notes',
];
export function isFundSortColumn(id) {
    return FUND_SORT_COLUMNS.includes(id);
}
//# sourceMappingURL=fundSort.js.map